import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Spinner,
  Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";
import { ToWords } from "to-words";

// import "../app-invoice.css";
import { getPODocReport } from "../../../store/Reports/actions";
import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import LoadingModel from "../../LoadingModel";
import { currentPdfType } from "../../../store/Reports/actions";

class POReportDocument extends Component {
  constructor(props) {
    super(props);
    this.state = { amountInWords: "" };
  }

  componentDidMount() {
    this.props.getPODocReport(this.props.match.params.id, this.props.POPdf);
  }

 

  getPDFReport = async () => {
    const element = document.getElementById("toPdf");
    if (!element) return;

    const originalWidth = element.style.width;
    element.style.width = "297mm";
    element.style.maxWidth = "290mm";

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // Use a higher scale for better text clarity
    const canvas = await html2canvas(element, {
      scale: 1.5,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("Purchase_Order_Report.pdf");

    // Revert back to original
    element.style.width = originalWidth;
  };

  reportBody() {
    const printType = currentPdfType;
    const toWords = new ToWords();
    return (
      <>
        <Row className="p-1 report-preview">
          <Col md={12} className="p-1">
            <Card className="p-1 report-preview-card">
              <CardBody className="report-padding pb-0">
                <div className="report-body flex-sm-row flex-column  mt-0">
                  <div className=" ">
                    <h5 className="card-title-16 pt-2 ">
                      SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                    </h5>
                    <p className="card-title-14 pt-2 mb-0">
                      Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP
                    </p>
                    <p className="card-title-14 pt-2 mb-0">
                      Phone No.0884-2326661, 62, Mobile No.9494154547,
                    </p>
                    <p className="card-title-14 pt-2 mb-0">
                      Email: purchase@sleipl.com, lalitharice@gmail.com
                    </p>
                    <p className="card-title-14 pt-2">
                      GSTIN : 37AAKCS3233N1ZX
                    </p>
                  </div>
                  <div className="pt-2">
                    <span className="p-4">
                      <img
                        className="img-fluid p-0"
                        src={SLE_logo}
                        alt="Logo"
                        width="100"
                        height="120"
                      />
                    </span>
                    <h4 className="report-title mb-0">PURCHASE ORDER </h4>
                    <h5 className="report-title">
                      <span className="report-number">
                        #{this.props.PO_Doc_report.code}
                      </span>
                    </h5>
                  </div>
                </div>
                <hr className="hr-black-color " />

                <div className="report-body flex-sm-row flex-column mt-0">
                  <div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Vendor Name:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.vendor?.name}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Vendor Location:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.vendor?.city}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Vendor Phone:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.vendor?.mobile}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Vendor GST:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.vendor?.gstno}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>RFD Code:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.requestforquotation_code}
                      </p>
                    </div>

                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Sub Location</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.sublocation?.name
                          ? this.props.PO_Doc_report.sublocation?.name
                          : ""}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Transport By</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report?.transport_by_name
                          ? this.props.PO_Doc_report.transport_by_name
                          : ""}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Prepared Date:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.createdon}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Quotation Code:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.quotation_code}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Quotation Date:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.quotation_date && (
                          <>
                            {moment(
                              this.props.PO_Doc_report.quotation_date,
                            ).format("DD-MM-YYYY")}
                          </>
                        )}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>PO Location:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.location?.name}
                      </p>
                    </div>

                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>PO Type:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.purchase_type_name}
                      </p>
                    </div>

                    <div className="report-wrapper">
                      <p className={printType === "internal" ? "report-wrapper-title font-size-18" : "report-wrapper-title"}>Cost Center Type:</p>
                      <p className={printType === "internal" ? "report-wrapper-det font-size-15" : "report-wrapper-det"}>
                        {this.props.PO_Doc_report.sublocation
                          ?.cost_center_type_name
                          ? this.props.PO_Doc_report.sublocation
                              ?.cost_center_type_name
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>
                <hr className="hr-black-color " />
                <div className="m-0">
                  {this.props.loading ? (
                    <div className="text-center">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <div className="table-responsive">
                    <Table
                      // striped
                      bordered
                      // hover
                      className="mb-0 p-0 table-centered table-color-black "
                      style={{ tableLayout: "fixed", width: "100%" }}
                    >
                      <thead className="bg-light text-center" >
                      
                        <tr>
                          <th 
                            style={{ width: "3%" }} 
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            S.NO
                          </th>
                          <th
                            style={{ width: "13%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Item Image 
                          </th>
                          <th
                            style={{ width: "17%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Item Name
                          </th>
                          <th 
                            style={{ width: "9%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Quantity / Units
                          </th>
                          <th 
                            style={{ width: "8%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Item Base Price
                          </th>
                          <th 
                            style={{ width: "8%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Item Discount(%)
                          </th>
                          <th 
                            style={{ width: "9%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Item Price
                            <br />
                            <sup>(Discount)</sup>
                          </th>
                          <th 
                            style={{ width: "7%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Tax Type (%)
                          </th>
                          <th 
                            style={{ width: "9%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Tax Amount
                          </th>
                          <th 
                            style={{ width: "22%" }}
                            className={
                              printType === "internal"
                                ? "text-center font-size-18 font-weight-bold"
                                : "text-center"
                            }
                          >
                            Gross Value
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.PO_Doc_report?.poitems?.map((item, key) => (
                          <React.Fragment key={key}>
                            {/* ── Main row ───────────────────────────── */}
                            <tr className="item-block">
                              <td 
                              className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }
                              >{key + 1}</td>

                              <td className="nowrap text-center">
                                <div className="product-detail text-center">
                                  <img
                                    src={item?.product?.image ?? DefaultImg}
                                    alt="product-img"
                                    className="product-img img-fluid mx-auto tab-img rounded"
                                    style={{
                                      height: "200px",
                                      width: "400px",
                                    }}
                                  />
                                </div>
                              </td>

                              <td>
                                <p className={
                                    printType === "internal"
                                      ? "text-center font-size-18 font-weight-bold "
                                      : "text-center font-weight-bold"
                                  }>
                                  {item?.product?.name}
                                </p>
                                <p className={
                                    printType === "internal"
                                      ? "text-center font-size-15 "
                                      : "text-center"
                                  }>
                                  <b>Item Group:</b>{" "}
                                  <span >
                                    {item.product?.group?.name}
                                  </span>
                                </p>
                                {/* {printType === "internal" && (
                                  <>
                                    <p className="mb-0 text-black">
                                      <b
                                        style={{
                                          fontWeight: 800,
                                        }}
                                      >
                                        Highest Price:
                                      </b>{" "}
                                      <span
                                        style={{
                                          fontWeight: 800,
                                        }}
                                        className="font-weight-medium text-black"
                                      >
                                        {item.highest_baseprice} (
                                        {item.highest_po_code.pocode}
                                        )
                                        <br />({item.highest_po_code?.vendor})
                                      </span>
                                    </p>

                                    <p className="mb-0 text-black">
                                      <b
                                        style={{
                                          fontWeight: 800,
                                        }}
                                      >
                                        Highest Tax Type:
                                      </b>{" "}
                                      <span
                                        style={{
                                          fontWeight: 800,
                                        }}
                                        className="font-weight-medium text-black"
                                      >
                                        {item.highest_po_code.taxtype_name} (
                                        {item.highest_po_code.tax})
                                      </span>
                                    </p>

                                    <p className="mb-0 text-black">
                                      <b
                                        style={{
                                          fontWeight: 800,
                                        }}
                                      >
                                        Lowest Price:
                                      </b>{" "}
                                      <span
                                        style={{
                                          fontWeight: 800,
                                        }}
                                        className="font-weight-medium text-black"
                                      >
                                        {item.lowest_baseprice} (
                                        {item.lowest_po_code.pocode}
                                        )
                                        <br />({item.lowest_po_code?.vendor})
                                      </span>
                                    </p>

                                    <p className="mb-0 text-black">
                                      <b
                                        style={{
                                          fontWeight: 800,
                                        }}
                                      >
                                        Lowest Tax Type:
                                      </b>{" "}
                                      <span
                                        style={{
                                          fontWeight: 800,
                                        }}
                                        className="font-weight-medium text-black"
                                      >
                                        {item.lowest_po_code.taxtype_name} (
                                        {item.lowest_po_code.tax})
                                      </span>
                                    </p>

                                    <p className="mb-0 text-black">
                                      <b
                                        style={{
                                          fontWeight: 800,
                                        }}
                                      >
                                        Latest Price:
                                      </b>{" "}
                                      <span
                                        style={{
                                          fontWeight: 800,
                                        }}
                                        className="font-weight-medium text-black"
                                      >
                                        {item.latest_vendor_baseprice?.price} (
                                        {item.latest_vendor_baseprice?.pocode})
                                      </span>
                                    </p>
                                    {item.last_month_purchase_rate && (
                                      <>
                                        <p className="mb-0 text-black">
                                          <b style={{ fontWeight: 800 }}>
                                            Last Month Purchase Rate:
                                          </b>{" "}
                                          <span
                                            style={{ fontWeight: 800 }}
                                            className="font-weight-medium text-black"
                                          >
                                            {item.last_month_purchase_rate.baseprice}
                                            {" "}({item.last_month_purchase_rate.pocode} - {item.last_month_purchase_rate.vendor}, {item.last_month_purchase_rate.date})
                                          </span>
                                        </p>
                                        <p className="mb-0 text-black">
                                          <b style={{ fontWeight: 800 }}>
                                            Last 30 days Purchase Qty:
                                          </b>{" "}
                                          <span
                                            style={{ fontWeight: 800 }}
                                            className="font-weight-medium text-black"
                                          >
                                            {item.last_month_purchase_rate.qty} {item.last_month_purchase_rate.unit}
                                          </span>
                                        </p>
                                          <p className="mb-0 text-black">
                                          <b style={{ fontWeight: 800 }}>
                                            Last 30 days Issued Qty:
                                          </b>{" "}
                                          <span
                                            style={{ fontWeight: 800 }}
                                            className="font-weight-medium text-black"
                                          >
                                            {item.last_month_issued_quantity} {item.last_month_issued_quantity  }
                                          </span>
                                        </p>
                                      </>
                                    )}
                                    <p className="mb-0 text-black">
                                      <b
                                        style={{
                                          fontWeight: 800,
                                        }}
                                      >
                                        MR Codes :
                                      </b>{" "}
                                      <span
                                        style={{
                                          fontWeight: 800,
                                        }}
                                        className="font-weight-medium text-black"
                                      >
                                        {item.mr_codes
                                          ?.map((c) => c.code)
                                          .join(", ")}
                                      </span>
                                    </p>
                                  </>
                                )}

                                {item.poi_acknowledges.length !== 0 && (
                                  <>
                                    <p className="mb-0">
                                      <b className="text-danger">
                                        Acknowledge:
                                      </b>{" "}
                                      <span className="font-weight-medium">
                                        {item.poi_acknowledges[0].description}
                                      </span>
                                    </p>
                                    <p className="mb-0">
                                      <b className="text-danger">
                                        Acknowledge By:
                                      </b>{" "}
                                      <span className="font-weight-medium">
                                        {item.poi_acknowledges[0].createdby}
                                      </span>
                                    </p>
                                  </>
                                )} */}
                              </td>

                              <td 
                              className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }>

                              {/* {Number(item.qty).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                               })} */}

                                {item.qty} 
                                <br />
                                {item.unit?.name}
                              </td>
                              <td 
                              className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }>
                  
                                 {Number(item.baseprice).toLocaleString("en-IN", {
                                       minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                 })}

                                    {/* {item.baseprice} */}
                                    
                                    </td>
                              <td className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }>
                                {item.discountpercent}%
                              </td>
                              <td className={
                                    printType === "internal"
                                      ? "text-center font-size-18 font-weight-bold"
                                      : "text-center"
                                  }>

                              {Number(item.price).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}

                                {/* {item.price} */}
                                <br />
                                <sup>({item.discount})</sup>
                              </td>
                              <td 
                              className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }>
                                {parseInt(item.taxtype) === 1
                                  ? "Inclusive"
                                  : "Exclusive"}{" "}
                                ({item.tax.name})
                              </td>
                              <td 
                              className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }>
                       
                                    {Number(item.taxamount).toLocaleString("en-IN", {
                                       minimumFractionDigits: 2,
                                       maximumFractionDigits: 2,
                                    })}
                             
                                    {/* {item.taxamount} */}
                                    </td>
                              <td 
                              className={
                                    printType === "internal"
                                      ? "text-center font-size-18 "
                                      : "text-center"
                                  }>
                     
                                  {Number(item.gross).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}

                                    {/* {item.gross} */}
                                    </td>
                            </tr>

                            {/* ── Single row for Make + Specifications + Description ───── */}
                            <tr className="item-block">
                              <td colSpan={10} className="bg-light">
                                <p 
                                className={
                                    printType === "internal"
                                      ? "mb-1 font-size-18"
                                      : "mb-1"
                                  }>
                                  <strong>Make:</strong>{" "}
                                  <span className="font-weight-medium">
                                    {item.make || "—"}
                                  </span>
                                </p>

                                <p className={
                                    printType === "internal"
                                      ? "mb-1 font-size-18"
                                      : "mb-1"
                                  }>
                                  <strong>Specifications:</strong>{" "}
                                  {item.product.description ? (
                                    <span
                                      className="font-weight-medium"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          item.product.description.replaceAll(
                                            "\n",
                                            "<br/>",
                                          ),
                                      }}
                                    />
                                  ) : (
                                    "—"
                                  )}
                                </p>

                                <p className={
                                    printType === "internal"
                                      ? "mb-1 font-size-18"
                                      : "mb-1"
                                  }>
                                  <strong>Description:</strong>{" "}
                                  <span className="font-weight-medium">
                                    {item.description || "—"}
                                  </span>
                                </p>

                                {printType==="internal" && item.last_purchase_info &&  (
                                  <div className="mt-2 pt-2" >
                                    <p className="mb-1 font-size-22 font-weight-bold">
                                      Last Purchase Info:
                                    </p>
                                    <p className="mb-1">
                                      <strong className="font-size-18 font-weight-bold">PO Code:</strong>{" "}
                                      <span className="font-size-18 font-weight-medium">
                                        {item.last_purchase_info.po_code}
                                      </span>
                                    </p>
                                    <p className="mb-1">
                                      <strong className="font-size-18 font-weight-bold">PO Date:</strong>{" "}
                                      <span className="font-size-18 font-weight-medium">
                                        {item.last_purchase_info.po_date}
                                      </span>
                                    </p>
                                    
                                    {/* Three prices side by side */}
                                    <div className="d-flex justify-content-between mb-1">
                                      <p className="mb-0 flex-fill mr-2">
                                        <strong className="font-size-18 font-weight-bold">Rate:</strong>{" "}
                                        <span className="font-size-18 font-weight-medium">
                                          &#8377; {item.last_purchase_info.rate}
                                        </span>
                                      </p>
                                      
                                      <p className="mb-0 text-black flex-fill mr-2">
                                        <b className="font-size-18 font-weight-bold">
                                          Highest Price:
                                        </b>{" "}
                                        <span
                                         className="font-size-18 font-weight-medium"
                                        >
                                          {item.highest_baseprice} 
                                          {/* ({item.highest_po_code.pocode}) */}
                                          {/* <br />({item.highest_po_code?.vendor}) */}
                                        </span>
                                      </p>
                                      
                                      <p className="mb-0 text-black flex-fill">
                                        <b className="font-size-18 font-weight-bold">
                                          Lowest Price:
                                        </b>{" "}
                                        <span
                                          className="font-size-18 font-weight-medium"
                                        >
                                          {item.lowest_baseprice}
                                          {/* ({item.lowest_po_code.pocode}) */}
                                          {/* <br />({item.lowest_po_code?.vendor}) */}
                                        </span>
                                      </p>
                                    </div>
                                    
                                    <p className="mb-1">
                                      <strong className="font-size-18 font-weight-bold">Qty:</strong>{" "}
                                      <span className="font-size-18 font-weight-medium">
                                        {item.last_purchase_info.qty}
                                      </span>
                                    </p>
                                    <p className="mb-0">
                                      <strong className="font-size-18 font-weight-bold">Vendor:</strong>{" "}
                                      <span className="font-size-18 font-weight-medium">
                                        {item.last_purchase_info.vendor}
                                      </span>
                                    </p>
                                  </div>
                                )}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}

                      
                        <tr id="totalRow">
                          <td className={
                                    printType === "internal"
                                      ? "text-left font-size-24 font-weight-bold"
                                      : "text-left"
                                  }
                                  colSpan={9}
                                  >
                            Total
                          </td>
                          <td className={
                                    printType === "internal"
                                      ? "text-center font-size-24 font-weight-bold"
                                      : "text-center"
                                  }>
                                    {Number(this.props.PO_Doc_report.total).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                            {/* {this.props.PO_Doc_report.total} */}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    </div>
                  )}
                </div>
                <hr className="hr-black-color " />
                <Row>
                  <Col md={12}>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">Amount In Words :</p>
                      <p className="report-wrapper-det">
                        {this.props.PO_Doc_report.total
                          ? toWords.convert(
                              parseFloat(
                                parseFloat(
                                  this.props.PO_Doc_report.total,
                                ).toFixed(3),
                              ),
                              { currency: true },
                            )
                          : ""}
                      </p>
                    </div>
                  </Col>
                </Row>
                <hr className="hr-black-color " />
                {/* <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">{"Advance"}</p>
                    <p className="report-wrapper-det">
                      {this.props.PO_Doc_report.advance ? "Yes" : "No"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " />
              <Row>
                <Col md={12}>
                  <div className="report-wrapper">
                    <p className="report-wrapper-title">
                      {"Advance Percentage"}
                    </p>
                    <p className="report-wrapper-det">
                      {this.props.PO_Doc_report.advancepercentage}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr className="hr-black-color " /> */}
                <Row>
                  <Col md={12}>
                    <span className="TnCTitle mb-1">terms and conditions</span>
                  </Col>
                  <Col md={6} sm={6}>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">Delivery:</p>
                      <p className="report-wrapper-det">
                        {this.props.PO_Doc_report.delivery}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">Payment:</p>
                      <p className="report-wrapper-det">
                        {this.props.PO_Doc_report.payment}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">P & F:</p>
                      <p className="report-wrapper-det">
                        {this.props.PO_Doc_report.pnf}
                      </p>
                    </div>
                  </Col>
                  <Col md={6} sm={6}>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">Transport</p>
                      <p className="report-wrapper-det">
                        {this.props.PO_Doc_report.transport}
                      </p>
                    </div>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">GST:</p>
                      <p className="report-wrapper-det">
                        {this.props.PO_Doc_report.gstdetails}
                      </p>
                    </div>
                  </Col>
                </Row>
                <hr className="hr-black-color " />

                <Row>
                  <Col md={12}>
                    <div className="report-wrapper">
                      <p className="report-wrapper-title">{"Remarks"}</p>
                      <p className="report-wrapper-det">
                        {this.props.pdfType == "internal"
                          ? this.props.PO_Doc_report.remarks
                          : this.props.PO_Doc_report.externalremarks}
                      </p>
                    </div>
                  </Col>
                </Row>
                <hr className="hr-black-color " />
                {/* <Col md={6}>
									<div className="float-right">
										<div className="report-wrapper">
											<p className="report-wrapper-title">
												Prepared by:
											</p>
											<p className="report-wrapper-det">
												{this.props.PO_Doc_report[
													"Created By"
												] && (
													<>
														{
															this.props
																.PO_Doc_report[
																"Created By"
															]

															 ?.fullname
														}{" "}
														(
														{
															this.props
																.PO_Doc_report
																.createdby
																?.fullname
														}
														)
														{this.props.PO_Doc_report.createdby?.fullname}
													</>
												)}
											</p>
										</div>
									</div>
								</Col> */}
                <Row>
                  <Col md={12}>
                    <div className="text-black">
                      <ol>
                        <li>
                          The supplier has to file the GST returns regularly and
                          ensure compliance to GST rules and regulations in
                          respect of supply
                        </li>
                        <li>
                          if we are denied ITC owing to your non-compliance,
                          then we will recover the ITC amount along with
                          interest, penalty etc. from your pending paymetns.
                        </li>
                      </ol>
                      <p style={{ textIndent: "30px" }}>
                        As per section 194Q TDS0.1% (of 5% if the buyer has not
                        filed IT returns of two previour yeards) will be
                        deducted on all purchase bills value exceeding fifty
                        lack rupees in any previous year and hence supplier
                        shall not charge TCS on Sales of goods as per section
                        206C (1H) @0.1%
                      </p>
                    </div>
                  </Col>
                </Row>
                <hr className="hr-black-color " />
                <Row>
                  <Col md={6}>
                    <p className="text-black">
                      Thanking you,
                      <br /> Yours Faithfully
                      <br />
                      For SRI LALITHA ENTERPRISES INDUSTRIES PVT LTD.
                    </p>
                  </Col>

                  <Col md={6}>
                    <div className="float-right">
                      <div className="report-wrapper">
                        <p className="report-wrapper-title">Prepared by:</p>
                        {this.props.PO_Doc_report?.createdby?.fullname ? (
                          <p className="report-wrapper-det">
                            {this.props.PO_Doc_report.createdby.fullname}
                          </p>
                        ) : (
                          <p className="report-wrapper-det">—</p> // fallback if not available
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md={12} className="mt-4">
                    <spam className="mb-4 text-black">
                      <b>Managing Director</b>
                    </spam>
                  </Col>
                </Row>
                <hr className="hr-black-color printme " />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print ">
                    <Link
                      to="#"
                      onClick={() => this.props.history.goBack()}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    {/* {this.props.POPdf ? (
                      <Link
                        to={"/PurchaseOrder/" + this.props.match.params.id}
                        
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/poreport"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    )} */}

                    <div className="float-right">
                      <div className="d-inline-block ">
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getPDFReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            PDF
                          </span>
                        </Button>

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-1 mr-auto mx-auto" id="toPdf">
                    {this.reportBody()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { PO_Doc_report, POPdf, loading, pdfType } = state.reports;
  return {
    PO_Doc_report,
    POPdf,
    loading,
    pdfType,
  };
};

export default connect(mapStatetoProps, {
  getPODocReport,
})(POReportDocument);
